import { render } from "./aio-login-card.vue?vue&type=template&id=31af234a&scoped=true"
import script from "./aio-login-card.vue?vue&type=script&lang=js"
export * from "./aio-login-card.vue?vue&type=script&lang=js"

import "./aio-login-card.vue?vue&type=style&index=0&id=31af234a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31af234a"]])

export default __exports__